import { render, staticRenderFns } from "./MasterCardLogo.vue?vue&type=template&id=3c042701&scoped=true&"
import script from "./MasterCardLogo.vue?vue&type=script&lang=js&"
export * from "./MasterCardLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c042701",
  null
  
)

export default component.exports